exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sw_form .input_100{width:100%}.sw_form .input_90{width:90%}.sw_form .input_80{width:80%}.sw_form .input_70{width:70%}.sw_form .input_50{width:50%}.sw_form .input_40{width:40%}", ""]);

// exports
